import { Http } from '../../shared';
import { settings } from '../../settings';

export class OrderService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }

    async find(id, orderToken) {
        const tokenQuery = orderToken ? `?order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.get(`${this.service_url}/orders/${id}${tokenQuery}`);
        return response.data;
    }
    async findAnonymous(query) {
        var response = await this.http.get(`${this.service_url}/find-anonymous-orders?${new URLSearchParams(query)}`);
        return response.data;
    }
    async search(query) {
        var response = await this.http.get(`${this.service_url}/orders?${new URLSearchParams(query)}`);
        return response.data;
    }
    async updateContact(order_id, contact, orderToken) {
        const tokenQuery = orderToken ? `?order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.put(`${this.service_url}/orders/${order_id}/contact${tokenQuery}`, contact);
        return response.data;
    }
    async updateVehicles(order_id, v, orderToken) {
        const tokenQuery = orderToken ? `?order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.put(`${this.service_url}/orders/${order_id}/vehicles${tokenQuery}`, v);
        return response.data;
    }
    async cancel(order_id, orderToken) {
        const tokenQuery = orderToken ? `?order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.post(`${this.service_url}/orders/${order_id}/cancel${tokenQuery}`, {});
        return response.data;
    }
    async cancelLeg(id, leg_id, data, orderToken) {
        const tokenQuery = orderToken ? `?order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.post(`${this.service_url}/orders/${id}/legs/${leg_id}/cancel${tokenQuery}`, data);
        return response.data;
    }
    async createCheckout(id, data, orderToken) {
        const tokenQuery = orderToken ? `?order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.post(`${this.service_url}/orders/${id}/checkouts${tokenQuery}`, data);
        return response.data;
    }
    async getPdf(id, template, orderToken) {
        var options = {
            responseType: 'blob'
        }
        const tokenQuery = orderToken ? `&order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.get(`${this.service_url}/orders/${id}/pdf?template=${template}${tokenQuery}`, options);
        return response.data;
    }
    async getHtml(id, template, orderToken) {
        const tokenQuery = orderToken ? `&order_token=${encodeURIComponent(orderToken)}` : '';
        var response = await this.http.get(`${this.service_url}/orders/${id}/html?template=${template}${tokenQuery}`);
        return response.data;
    }
}
